export default class DegenerateEventTarget {
	constructor() {
		throw new Error('EventTarget is not defined');
	}
}
